"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const util_1 = require("../util");
const { GET } = util_1.httpMethods;
/**
 * @classdesc Represents the class interfacing maintenance owner related API-I endpoints
 * @class
 */
class MaintenanceOwners {
    constructor(api) {
        this.api = api;
    }
    /**
     * Get properties according to the parameters provided
     *
     * @see {@link https://noc2-stage.semios.com/api-internal-docs#maintenance-ownership-maintenance-owner-provider-get}
     * @param {Object} args={} - An object containing the arguments accepted by the API
     * @param {?string} args.internal - Optional. Set 'only' to return all internal maintenance owner providers
     * @return {promise} Assets - Returns a Promise that, when fulfilled, will either return an object of data or an error with the problem
     */
    async getMaintenanceOwners(args) {
        const { internal } = args || {};
        const methodName = 'getMaintenanceOwners';
        // validate
        const validations = [(0, util_1.validateParam)(methodName, 'internal', internal, util_1.ValidationTypes.STRING)];
        (0, util_1.validateParams)(validations);
        const route = 'maintenance_owner_providers';
        const input = {
            query: {
                internal,
            },
        };
        const formattedInput = (0, util_1.setFormattedInput)(input);
        return this.api.send(GET, route, formattedInput);
    }
}
exports.default = MaintenanceOwners;
//# sourceMappingURL=maintenance-owners.js.map